import { create } from 'zustand';

const useSuppliersStore = create((set) => ({
  showCreateSupplierModal: false,
  // When the modal opens in edit mode, this holds the supplier id being
  // edited. Null = create mode.
  editingSupplierId: null,
  selectedSupplier: null,
  isImportOpen: false,
  isEmissionsImportOpen: false,

  setShowCreateSupplierModal: (show) => set({ showCreateSupplierModal: show }),
  setSelectedSupplier: (supplier) => set({ selectedSupplier: supplier }),
  setIsImportOpen: (isOpen) => set({ isImportOpen: isOpen }),
  setIsEmissionsImportOpen: (isOpen) => set({ isEmissionsImportOpen: isOpen }),

  // Convenience actions for the supplier modal. Pass an id to open in edit
  // mode; omit (or pass null) for create mode.
  openSupplierModal: (id = null) => set({ showCreateSupplierModal: true, editingSupplierId: id }),
  closeSupplierModal: () => set({ showCreateSupplierModal: false, editingSupplierId: null }),

  // Upload guide gating — hoisted so the page header can trigger the
  // upload flow from above the table without cross-cutting refs into
  // SuppliersTable. The wizard + guide modals still mount inside the
  // table where their submit/error handlers sit. Mirrors the pattern used
  // for shipment uploads.
  showSupplierUploadGuide: false,
  setShowSupplierUploadGuide: (open) => set({ showSupplierUploadGuide: open }),

  triggerUploadFlow: () => {
    let hasSkipped = false;
    try {
      hasSkipped = window.localStorage.getItem('suppliers-upload-guide-skip') === 'always';
    } catch (_err) {
      // Ignore storage failures (private mode etc.).
    }
    if (hasSkipped) {
      set({ isImportOpen: true });
    } else {
      set({ showSupplierUploadGuide: true });
    }
  },

  // Connect-supplier modal — hoisted so the page header's "Connect supplier"
  // tertiary action can trigger the flow from above the table. The modal
  // itself still mounts inside SuppliersTable where the connect mutation
  // and form state live.
  showConnectSupplierModal: false,
  setShowConnectSupplierModal: (show) => set({ showConnectSupplierModal: show }),

  // Every modal flag this store gates, shut. Called on navigation — see
  // useCloseModalsOnNavigate. These flags are module-global and outlive the
  // page that set them: leaving one true means the modal reappears the next
  // time Suppliers mounts, stacked under whatever the user opens next.
  closeAllModals: () =>
    set({
      showCreateSupplierModal: false,
      editingSupplierId: null,
      isImportOpen: false,
      isEmissionsImportOpen: false,
      showSupplierUploadGuide: false,
      showConnectSupplierModal: false,
    }),
}));

export default useSuppliersStore;
